module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', [_c('div', {
    staticClass: "item"
  }, [_vm._v("订单编号：" + _vm._s(_vm.order.id))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("设备编号：" + _vm._s(_vm.order.deviceId))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("套餐名称：" + _vm._s(_vm.order.orderPackage.packageName))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("订单金额：" + _vm._s(_vm.order.orderPackage.packagePrice * _vm.order.quantity))]), _vm._v(" "), _c('div', {
    staticClass: "item"
  }, [_vm._v("订单状态：" + _vm._s(_vm.orderStatus[_vm.order.status]))]), _vm._v(" "), (_vm.startSuccess) ? _c('div', {
    staticClass: "success"
  }, [_c('el-alert', {
    attrs: {
      "title": "启动成功",
      "description": "设备已成功启动！",
      "type": "success",
      "show-icon": "",
      "closable": false
    }
  })], 1) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c813b7b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/client/pay.vue
// module id = 1128
// module chunks = 2